
var parkingForm = document.getElementById('bookparking');
if(parkingForm) {

    jQuery(document).ready(function($) {
        'use strict';

        var today = new Date();
        var nextDay = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate() + 1,
        );
        var dd = nextDay.getDate().toString();
        var mm = nextDay.getMonth() + 1; //January is 0!
        var yyyy = nextDay.getFullYear();

        if (dd.length == 1) {
            dd = '0' + nextDay.getDate().toString();
        }

        if (mm.length == 1) {
            mm = '0' + nextDay.getDate().toString();
        }

        var my = mm.toString() + yyyy.toString();

        var threeDaysForward = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate() + 3,
        );

        var dd2 = threeDaysForward.getDate().toString();
        var mm2 = threeDaysForward.getMonth() + 1;
        var yyyy2 = threeDaysForward.getFullYear();

        if (dd2.length == 1) {
            dd2 = '0' + threeDaysForward.getDate().toString();
        }

        if (mm2.length == 1) {
            mm2 = '0' + (threeDaysForward.getMonth() + 1).toString();
        }

        var my2 = mm2.toString() + yyyy2.toString();

        $('#parking_start_day').val(dd - 1);
        $('#parking_end_day').val(dd2);
        //$('#ddmy').val(my); // not need. We set it in php with selected
        //$('#rdmy').val(my2); // not need. We set it in php with selected

        function padTime(i) {
            return i < 10 ? '0' + i : i;
        }

        // Setup start time and specific times
        var currentHours = today.getHours();
        var currentMinutes = today.getMinutes();

        var currentTime;

        // Round hour
        currentTime =
            padTime(currentHours + (currentMinutes >= 59 ? 1 : 0)) + ':00';
        // Next day
        if (currentTime === '24:00') {
            currentTime = '00:00';
        }

        // Välj rätt tid i dropdown för starttiden
        $('#parking_start_time').val(currentTime);

        // Hämta referenser till klockdropdowns
        var parkingStartTimeSelect = document.getElementById(
            'parking_start_time');
        var parkingEndTimeSelect = document.getElementById('parking_end_time');
        //console.log('Updating start time select:', parkingStartTimeSelect);
        //console.log('Updating end time select:', parkingEndTimeSelect);
        // Anropa updateTimes för att fylla i tider
        //updateTimes(parkingStartTimeSelect);
        //updateTimes(parkingEndTimeSelect);

        $('#frmSignup').find('select').on('change', function(e) {
            updateAction();
        });

        $('#frmSignup').find('input').on('change', function(e) {
            updateAction();
        });

        updateAction();
    });

    function updateAction() {
        var inDay = jQuery('#ddd').val();
        var inMonth = jQuery('#ddmy').val();
        var inTime = jQuery('#ddt').val();

        var outDay = jQuery('#rdd').val();
        var outMonth = jQuery('#rdmy').val();
        var outTime = jQuery('#rdt').val();

        var promo = jQuery('#pc').val();

        var link = 'https://secure-booking.skavsta.se/skavstanewbooking/startpage.aspx?qsddd=%inDay%&qsddmy=%inMonth%&qsddt=%inTime%&qsrdd=%outDay%&qsrdmy=%outMonth%&qsrdt=%outTime%&qspc=%promo%&qsap=NYO&qsjs=N&qspp=CP'
            .replace('%inDay%', inDay)
            .replace('%inMonth', inMonth)
            .replace('%inTime%', encodeURIComponent(inTime))
            .replace('%outDay%', outDay)
            .replace('%outMonth%', outMonth)
            .replace('%outTime%', encodeURIComponent(outTime))
            .replace('%promo%', promo);
        jQuery('#frmSignup').attr('action', link);
    }

    var form = document.getElementById('frmSignup');
    if (form) {
        document.getElementById('frmSignup')
            .addEventListener('submit', function(event) {
                event.preventDefault();

                // Hämta värden för dag och tid
                const startDay = document.getElementById('parking_start_day').value;
                const startTime = document.getElementById('parking_start_time').value;
                const endDay = document.getElementById('parking_end_day').value;
                const endTime = document.getElementById('parking_end_time').value;

                const startMonthYear = document.getElementById('ddmy').value; // Format mmYYYY
                const endMonthYear = document.getElementById('rdmy').value;   // Format mmYYYY

                const promoCode = document.getElementById('pc').value;

                const startMonth = startMonthYear.slice(0, 2); // mm from ddmy
                const startYear = startMonthYear.slice(2);     // YYYY from ddmy
                const endMonth = endMonthYear.slice(0, 2);     // mm from rdmy
                const endYear = endMonthYear.slice(2);         // YYYY from rdmy

                const parkingStart = `${startYear}-${startMonth}-${startDay} ${startTime}`;
                const parkingEnd = `${endYear}-${endMonth}-${endDay} ${endTime}`;

                var actionUrl = '';

                //console.log('Environment type:', wpData.environment);

                if (wpData.environment === 'production') {
                    actionUrl =
                        `https://www.parkifly.com/parkifly/skavsta/booking;parking_start=${encodeURIComponent(
                            parkingStart)};parking_end=${encodeURIComponent(
                            parkingEnd)};discount_code=${encodeURIComponent(
                            promoCode)}`;
                } else {
                    actionUrl =
                        `https://shuttlebuss-web-test.wittysand-9ea05a62.westeurope.azurecontainerapps.io/parkifly/skavsta/booking;parking_start=${encodeURIComponent(
                            parkingStart)};parking_end=${encodeURIComponent(
                            parkingEnd)};discount_code=${encodeURIComponent(
                            promoCode)}`;
                }

                // Go url
                window.open(actionUrl, '_blank');
            });
    }

// Get refs
    var startDaySelect = document.getElementById('parking_start_day');
    var endDaySelect = document.getElementById('parking_end_day');
    var monthYearSelectStart = document.getElementById('ddmy');
    var monthYearSelectEnd = document.getElementById('rdmy');

// Function to update days etc in dropdown
    function updateDays(selectElement, monthYear) {
        var month = parseInt(monthYear.substring(0, 2), 10); // Få månad från mmyyyy
        var year = parseInt(monthYear.substring(2, 6), 10);  // Få år

        var daysInMonth = new Date(year, month, 0).getDate();
        var today = new Date();
        var selectedDay = selectElement.value;

        selectElement.innerHTML = '';

        for (var day = 1; day <= daysInMonth; day++) {
            var option = document.createElement('option');
            option.value = day < 10 ? '0' + day : day;
            option.textContent = day < 10 ? '0' + day : day;

            // Kolla om datumet är tidigare än idag
            var dateToCheck = new Date(year, month - 1, day + 1); // Måste subtrahera 1 från månaden
            if (dateToCheck < today) {
                option.disabled = true; // Inaktivera alternativet om det är ett tidigare datum
            }

            selectElement.appendChild(option);
        }

        // Om det valda datumet inte finns, sätt sista datum i månaden
        if (selectedDay &&
            Array.from(selectElement.options)
                .some(option => option.value === selectedDay)) {
            selectElement.value = selectedDay;
        } else {
            selectElement.value =
                daysInMonth < 10 ? '0' + daysInMonth : daysInMonth;
        }
    }

// Pad function to ensure two-digit formatting
    function padTime(i) {
        return i < 10 ? '0' + i : i.toString();
    }

// Update times function
    function updateTimes(selectElement, updateDrop) {
        // Kontrollera att det är ett HTMLSelectElement
        if (!(selectElement instanceof HTMLSelectElement)) {
            console.error(
                'Elementet är inte ett giltigt <select> element:',
                selectElement
            );
            return;
        }

        var today = new Date();
        var currentHour = today.getHours();
        var currentMinutes = today.getMinutes();

        // Rensa befintliga alternativ
        selectElement.innerHTML = '';

        // Loop genom timmar
        for (var hour = 0; hour < 24; hour++) {
            for (var minute = 0; minute < 60; minute += 30) { // Exempel: 30-minuters intervall
                var timeValue = padTime(hour) + ':' + padTime(minute);
                var option = document.createElement('option');
                option.value = timeValue;
                option.textContent = timeValue;

                if (updateDrop) {
                    // Kolla om tiden är tidigare än nu
                    if (hour <
                        currentHour ||
                        (hour === currentHour && minute < currentMinutes)) {
                        option.disabled = true; // Inaktivera alternativet om det är en tidigare tid
                    }
                }
                selectElement.appendChild(option);
            }
        }
    }

    function checkAndUpdateTime() {
        const startDay = document.getElementById('parking_start_day').value;
        const startTime = document.getElementById('parking_start_time').value;
        const startMonthYear = document.getElementById('ddmy').value; // Format mmYYYY

        const startMonth = startMonthYear.slice(0, 2);
        const startYear = startMonthYear.slice(2);

        const startFormatted = startDay.padStart(2, '0') +
            startMonth +
            startYear;

        const today1 = new Date();
        const day = String(today1.getDate()).padStart(2, '0');
        const month = String(today1.getMonth() + 1).padStart(2, '0');
        const year = today1.getFullYear();
        const todayFormatted = day + month + year;

        if (startFormatted === todayFormatted) {
            updateTimes(document.getElementById('parking_start_time'), true);
        } else {
            updateTimes(document.getElementById('parking_start_time'), false);
        }

    }

// Init
    function initializeDays() {
        var startMonthYear = monthYearSelectStart.value;
        var endMonthYear = monthYearSelectEnd.value;

        updateDays(startDaySelect, startMonthYear);
        updateDays(endDaySelect, endMonthYear);
    }

// Uppdatera när användaren byter dag
    var parking_start_day = document.getElementById('parking_start_day');
    if (parking_start_day) {
        document.getElementById('parking_start_day')
            .addEventListener('change', function() {
                checkAndUpdateTime();
            });
    }

    monthYearSelectStart.addEventListener('change', function() {
        var selectedStartMonthYear = this.value; // mmYYYY
        var selectedEndMonthYear = monthYearSelectEnd.value; // mmYYYY from rdmy

        var startMonth = parseInt(selectedStartMonthYear.substring(0, 2), 10);
        var startYear = parseInt(selectedStartMonthYear.substring(2, 6), 10);

        var endMonth = parseInt(selectedEndMonthYear.substring(0, 2), 10);
        var endYear = parseInt(selectedEndMonthYear.substring(2, 6), 10);

        if (startYear >
            endYear ||
            (startYear === endYear && startMonth > endMonth)) {
            monthYearSelectEnd.value = selectedStartMonthYear;
            updateDays(endDaySelect, selectedStartMonthYear);
        }

        updateDays(startDaySelect, selectedStartMonthYear);
        checkAndUpdateTime();
    });

    monthYearSelectEnd.addEventListener('change', function() {
        var selectedEndMonthYear = this.value; // mmYYYY
        var selectedStartMonthYear = monthYearSelectStart.value; // mmYYYY from ddmy

        var startMonth = parseInt(selectedStartMonthYear.substring(0, 2), 10);
        var startYear = parseInt(selectedStartMonthYear.substring(2, 6), 10);

        var endMonth = parseInt(selectedEndMonthYear.substring(0, 2), 10);
        var endYear = parseInt(selectedEndMonthYear.substring(2, 6), 10);

        if (startYear >
            endYear ||
            (startYear === endYear && startMonth > endMonth)) {
            monthYearSelectStart.value = selectedEndMonthYear;
            //alert('Startdatum justeras till slutdatum då det inte kan vara senare!');
        }

        updateDays(endDaySelect, this.value);
    });

    window.onload = function() {
        setSelectedDay();
    };

    document.addEventListener('DOMContentLoaded', function() {

        setSelectedDay();
        checkAndUpdateTime();

        var startMonthYear = monthYearSelectStart.value;
        var endMonthYear = monthYearSelectEnd.value;

        // Check if the month-year values are valid
        if (startMonthYear && startMonthYear.length === 6) {
            updateDays(startDaySelect, startMonthYear);
        }
        if (endMonthYear && endMonthYear.length === 6) {
            updateDays(endDaySelect, endMonthYear);
        }
    });

    function setSelectedDay() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const parkingStartDaySelect = document.getElementById(
            'parking_start_day');

        if (parkingStartDaySelect) {
            const options = parkingStartDaySelect.options;
            for (let i = 0; i < options.length; i++) {
                if (options[i].value === day) {
                    options[i].selected = true; // Välj dagens datum
                    break;
                }
            }
        }
    }

// Correct the final `updateDays` call
    var today = new Date();
    var currentMonthYear = (today.getMonth() + 1).toString().padStart(2, '0') +
        today.getFullYear();
    updateDays(startDaySelect, currentMonthYear); // Pass startDaySelect as the first argument

}